import React from "react"
import lifecycle from "recompose/lifecycle"
import _ from "lodash"

export const Dump = lifecycle({
  componentWillMount() {
    // Stay quiet during automated tests; but this is convenient in UIs for debugging
    if (process.env.NODE_ENV !== "test") {
      console.log("debug.Dump", this.props)
    }
  },
})(props => {
  // js object's easier to read than an immutable map
  props = Object.assign({}, props, {
    firebaseState: props.firebaseState && props.firebaseState.toJS(),
  })
  // remove keys with circular references
  props = _.omit(props, ["children"])
  return <pre>{JSON.stringify(props, null, 2)}</pre>
})



// WEBPACK FOOTER //
// ./src/debug/Dump.js